import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react-router';

import { LandingHero as LandingHeroModule, type LandingHeroProps } from '@cx-modules/landing-hero';

export const LandingHero = (props: LandingHeroProps) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      captureException(error);
      return null;
    }}
  >
    <LandingHeroModule {...props} />
  </ErrorBoundary>
);
